import { render, staticRenderFns } from "./Imageicon.vue?vue&type=template&id=41a3dd4e"
import script from "./Imageicon.vue?vue&type=script&lang=js"
export * from "./Imageicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports